import cloneDeep from "lodash/cloneDeep";
import { createInFlightRequests } from "../helpers/inFlightRequests";
import { getResponseData } from "@helpers/_functions";
import BaseService from "./base.service";
import http from "../http-common";

class HolidayNameService extends BaseService {
  constructor() {
    super("holiday-name");
    this.pendingLists = createInFlightRequests();
  }

  getByEnterprise(enterpriseId) {
    const key = JSON.stringify([enterpriseId, localStorage.getItem("token")]);
    return this.pendingLists.run(key, () => http
      .get(`${this.path}/list-holiday/${enterpriseId}`)
      .then(response => getResponseData(response)))
      .then(data => cloneDeep(data));
  }

  upsert(data) {
    this.pendingLists.clear();
    return http.post(`${this.path}/upsert`, data).finally(() => this.pendingLists.clear());
  }
}

export default new HolidayNameService();